import { CatalogEnvService } from '@aipb/gulliver/catalog/env';
import { Routes } from '@angular/router';
import { NEWS } from './news.tokens';
import { NewsPageComponent } from './pages';

export const NewsRoutes: Routes = [
  {
    path: '',
    providers: [
      {
        provide: NEWS,
        useFactory: (catalogEnv: CatalogEnvService) => catalogEnv.env.news,
        deps: [CatalogEnvService]
      }
    ],
    component: NewsPageComponent
  }
];
